import { render, staticRenderFns } from "./dialogJsonForms.vue?vue&type=template&id=4b5a9cf0&scoped=true"
import script from "./dialogJsonForms.vue?vue&type=script&lang=js"
export * from "./dialogJsonForms.vue?vue&type=script&lang=js"
import style0 from "./dialogJsonForms.vue?vue&type=style&index=0&id=4b5a9cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a9cf0",
  null
  
)

export default component.exports